import React from 'react'

import Component from './component'

const JobContainer = (props) => {
  const mergedProps = {
  }

  return (
    <Component {...mergedProps} />
  )
}

export default JobContainer
